module.exports = __webpack_public_path__ + "8ee441a9a02f4102598673781ccb0ce2.png";